// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Breadcrumb-base__RV7QQ{display:flex;gap:var(--size-1);align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Breadcrumb-base__RV7QQ"
};
export default ___CSS_LOADER_EXPORT___;
